/** Access levels from minimum to maximum */
export enum AccessLevelEnum {
  /** Access defined - user cannot send any requests */
  FORBIDDEN = 0,
  /** Read-only access - user can send only `GET`-requests */
  READ = 1,
  /** Read-write access - user can send any requests */
  WRITE = 2,
}

/** All available access levels */
export const AVAILABLE_ACCESS_LEVELS: AccessLevelEnum[] = [
  AccessLevelEnum.FORBIDDEN,
  AccessLevelEnum.READ,
  AccessLevelEnum.WRITE,
];
